import { transformProgressDetailsDto } from 'data/transformers/payout';
export const transformRefund = _ref => {
  let {
    amount,
    currency,
    progress_details
  } = _ref;
  return {
    amount,
    currency,
    progressDetails: progress_details.map(transformProgressDetailsDto)
  };
};